import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoginRequestDto } from "@/dto/AdmDto";

/**
 * 로그인 폼 훅
 *
 * - useForm을 사용하여 로그인 폼의 로직을 분리합니다.
 * - useForm은 로그인 폼의 상태와 로직을 관리합니다.
 */
export default function useLoginForm(
  onSubmit: (data: LoginRequestDto) => void
) {
  const methods = useForm({
    resolver: yupResolver<LoginRequestDto>(
      yup.object().shape({
        admId: yup
          .string()
          .min(3, "아이디는 3자 이상이어야 합니다.")
          .required("아이디를 입력해주세요."),
        pwd: yup
          .string()
          .matches(
            /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/,
            "비밀번호는 영문과 숫자, 특수기호 조합하여 6자리 이상 입력하셔야 합니다."
          )
          .required("비밀번호를 입력해주세요."),
      })
    ),
    defaultValues: {
      admId: "",
      pwd: "",
    },
  });

  const handleSubmit = async () => {
    const isValid = await methods.trigger();

    if (isValid) {
      const data = methods.getValues();
      onSubmit(data);
    }
  };

  return {
    methods,
    handleSubmit,
  };
}
